import { render } from "./GlobalAlert.vue?vue&type=template&id=2d1033d0&scoped=true"
import script from "./GlobalAlert.vue?vue&type=script&lang=js"
export * from "./GlobalAlert.vue?vue&type=script&lang=js"

import "./GlobalAlert.vue?vue&type=style&index=0&id=2d1033d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1033d0"]])

export default __exports__